// extracted by mini-css-extract-plugin
export default {"stickyheader":"MainHeader_stickyheader__VMOO0","logo_img":"MainHeader_logo_img__F7LH7"};